import { Padding } from "@mui/icons-material";
import "./Tree.css";

// objs ---> rootObj with subs
// objs [obj1, obj2, ...]
// obj {id, pid, subs} 
export function sortToTree(rootid, data, opts, objs, visited){
    opts = opts || {};
    objs = objs || {};
    rootid = rootid || '';
    let isRoot;
    let idFld = opts.idFld || '__id';
    let pidFld = opts.pidFld || '__pid';
    if(!visited){
        visited = {};
        isRoot = true;
    }

    for(let idx in data){
        let obj = data[idx];
        // let processed = 0;
        if(!visited[obj[idFld]]){
            // has pid
            if(obj[pidFld]){
                // [] should not change == to === here
                if(obj[pidFld] == rootid){
                    // rootid visited
                    if(visited[rootid]){
                        let regObj = {
                            obj: obj,
                            subs: []
                        };
                        visited[obj[idFld]] = regObj;
                        visited[rootid]['subs'].push(regObj);

                        sortToTree(obj[idFld], data, opts, objs, visited);
                    }
                }
            }else{
                // root leaf
                objs['subs'] = objs['subs'] || [];
                let regObj = {
                    obj,
                    subs: []
                };
                objs['subs'].push(regObj);
                visited[obj[idFld]] = regObj;

                sortToTree(obj[idFld], data, opts, objs, visited);
            }
        }
    }
    //collect broken link ones
    // if(isRoot){
    //     objs['subs'] = objs['subs'] || [];
    //     for(idx in data){
    //         if(!visited[idx]){
    //             var obj = data[idx];
    //             var regObj = {
    //                 obj: obj
    //             };
    //             objs.subs.push(regObj);
    //         }                        
    //     }
    // }
    // console.log("objs:", objs);
    return objs;
}

export function treeToUl(tree, tagStart, tagEnd, opts){ //tree {obj, subs}
    opts = opts || {};
    var out = [];
    var obj = (tree.obj || {});
    console.log("obj:", obj);
    tagStart = tagStart || '<div class="ww-treelist">';
    tagEnd = tagEnd || '</div>';

    out.push(tagStart);
    {
        // out.push('<input type="checkbox" name="rowid" class="action-checkbox" value="'+ obj.id +'" title="select record" />');

        // out.push('<a class="icon" href="#" title="">');
        // out.push('<span class="fa fa-pencil glyphicon glyphicon-pencil"></span>');
        // out.push('</a>');

        // out.push('<a class="icon" href="#" title="">');
        // out.push('<span class="fa fa-eye glyphicon glyphicon-eye-open"></span>');
        // out.push('</a>');

        // out.push('<a class="icon" href="#" title="">');
        // out.push('<span class="fa fa-trash glyphicon glyphicon-trash"></span>');
        // out.push('</a>');

        // item info. if no item, use root
        out.push([
            obj.chkbox || '',
            obj.item || opts.root || `<span class="tree-list-leaf ww_leaf" leaf-id="1"> ${obj.name} </span>`, //'<span class="tree-list-leaf ww_leaf" leaf-id="0"> root </span>',
            obj.action,
        ].join(' '));

        //subs
        if(tree.subs && tree.subs.length>0){
            out.push('<ol>');
            for(let idx in tree.subs){
                out.push(treeToUl(tree.subs[idx], '<li>', '</li>', opts));
            }
            out.push('</ol>');
        }
    }

    out.push(tagEnd);
    console.log("out.join(' '):", out.join(' '));
    return out.join(' ');
}

//     rootid = rootid || '';
// let idFld = opts.idFld || '__id';
// let pidFld = opts.pidFld || '__pid';
// export default function Tree(props){
//     // https://stackoverflow.com/questions/23616226/insert-html-with-react-variable-statements-jsx
//     return <div dangerouslySetInnerHTML={{__html: treeToUl(sortToTree(false, props.rcds))}}>
//         {/* <h1>tree</h1>
//         {treeToUl(sortToTree(false, props.rcds))} */}
//         {/* {{__html: treeToUl(sortToTree(false, props.rcds))}} */}
//         {/* {{__html: `<div class="ww-treelist"> <span>aaaaa</span> <ol> <li> <span>aaaaa</span> <ol> <li> <span>aaaaa</span> </li> <li> <span>aaaaa</span> </li> </ol> </li> <li> <span>aaaaa</span> <ol> <li> <span>aaaaa</span> </li> <li> <span>aaaaa</span> </li> <li> <span>aaaaa</span> </li> <li> <span>aaaaa</span> <ol> <li> <span>aaaaa</span> </li> </ol> </li> </ol> </li> <li> <span>aaaaa</span> </li> </ol> </div>`}} */}
//         {/* {{__html: `<><div></div></>`}} */}
//     </div>;

// }

function TreeBranch({treeData, tblDef:tblDefIn, showFlds:showFldsIn, opts, activeRcdId, setActiveRcdId}){
    const branchId = window._ww_tools.uuidv4();
    const tblDef = tblDefIn || {};
    const showFlds= showFldsIn || tblDef.showFlds || Object.keys(tblDef.inputSettings || {}).filter(a=>a).join(',') || '__id';
    const getCaption = obj=>{
        return (showFlds||'__id').split(",").map(fldName=>obj[fldName]).filter(a=>String(a||"").trim()).join(" / ");
    }
    return <ul>
            {(treeData.subs||[]).map((treeLeaf,idx)=>{
                const caption = treeLeaf.obj?(getCaption(treeLeaf.obj)||"[blank]"):"root";
                const rcd=treeLeaf.obj;
                return <li key={branchId+'-'+idx}
                    className={"py-0 tree-branch"}
                >
                    <div
                        className={["ww_leaf tree-branch-data p-0",(treeLeaf.obj.__id==activeRcdId?"border border-primary rounded":"")].join(' ')}
                    >
                        <a href="#" role="button" 
                            className="link-underline-opacity-0 link-body-emphasis text-underline-hover me-1"
                            value={treeLeaf.obj?treeLeaf.obj.__id:""}
                            style={{lineHeight:"2em"}}
                        >{caption}</a>
                        <span className="ww_leaf_actions" style={{lineHeight:"2em", overflow:"hidden", verticalAlign:"bottom", margin:"0"}}>
                            {(opts.btns||[]).map((Wgt, wgtIdx)=>{
                                return <Wgt
                                    key={`wgt-${wgtIdx}`}
                                    rcd={rcd}
                                    rcdId={rcd.__id}
                                    rcdIdx={idx}
                                    listType={"Tree"}
                                    cb={_=>{
                                        setActiveRcdId&&setActiveRcdId(rcd.__id);
                                    }}
                                    style={{margin:"0", Padding:"0", maxHeight:"2em"}}
                                ></Wgt>
                            })}                            
                        </span>


                        {/* {tools||<span className="px-3 py-0 m-0 tree-branch-actions btn-group">
                            <button type="button"
                                className="btn btn-sm btn-primary px-1 py-0 m-0"
                                onClick={handleEdit}
                                rcdid={treeLeaf.obj.__id}
                            >edit</button>
                            <button type="button"
                                className="btn btn-sm btn-warning px-1 py-0 m-0"
                                onClick={handleDelete}
                                rcdid={treeLeaf.obj.__id}
                            >delete</button>
                            <button type="button"
                                className="btn btn-sm btn-secondary px-1 py-0 m-0"
                                onClick={evt=>{
                                    console.log("rcdpreset:", {"__pid":treeLeaf.obj.__id});
                                    handleNew({
                                        ...evt,
                                        ...{ rcdpreset:{"__pid":treeLeaf.obj.__id} }
                                    })
                                }}
                                rcdid={""}
                            >add sub record</button>
                        </span>}   */}
                    </div>

                    {treeLeaf.subs?<TreeBranch 
                        // treeData={treeLeaf}
                        // curRcdId={curRcdId}
                        showFlds={showFlds}
                        // tools={tools}

                        // handleDelete={handleDelete}
                        // handleNew={handleNew}
                        // handleEdit={handleEdit}
                        treeData={treeLeaf}

                        tblDef={tblDef}
                        opts={opts||{}}
                        activeRcdId={activeRcdId}
                        setActiveRcdId={setActiveRcdId}
                
                    />:""}
                </li>;
            })}
        </ul>;    
}


export default function Tree({rcds, tblDef, opts, activeRcdId, setActiveRcdId, listFlds:listFldsIn}){
    if(!tblDef)return<div>[Tree] tblDef null. </div>;

    opts = opts || {};

    // https://stackoverflow.com/questions/23616226/insert-html-with-react-variable-statements-jsx
    const treeData = sortToTree(false, rcds.rcds || rcds);
    const showFlds = (listFldsIn || ((opts.listFlds&&opts.listFlds) || (tblDef.listFlds?tblDef.listFlds:Object.keys(tblDef.inputSettings||{}).join(',')))).split(','); //['__id']
    
    return <TreeBranch
        treeData={treeData}

        tblDef={tblDef}
        opts={opts||{}}
        activeRcdId = {activeRcdId}
        setActiveRcdId = {setActiveRcdId}

        // curRcdId={curRcdId}
        showFlds={showFlds.join(',')}

        // tools={tools}

        // handleDelete={handleDelete}
        // handleNew={handleNew}
        // handleEdit={handleEdit}

    />;
}